import { fm } from 'Components/FormatMessage';
import { Container, Item } from 'Components/Grid';
import { editHistoryMenuItems } from 'Components/HistoryRowControls/EditHistory/EditHistoryDialog';
import HistoryRowVerticalItem from 'Components/HistoryRowVerticalItem';
import HistorySection from 'Components/HistorySection';
import { withHistoryContext } from 'Containers/FormContextHandler';
import * as React from 'react';
import { newButton } from 'Routes/Diagnosis/utils/functions';
import { isNil } from 'Utility/ramdaReplacement';

import type { IHistoryContext } from 'Containers/FormContextHandler';

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<'referringPhysicianAndUnit'>[] = [];
const ReferringPhysicianAndUnitHistory = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
  treatmentPeriod,
}: IHistoryContext<IDocumentWithTypeV2<'referringPhysicianAndUnit'>> & {
  treatmentPeriod: IDocumentWithTypeV2<'ninmtTreatmentPeriod'>;
}): React.JSX.Element => {
  const treatmentId = treatmentPeriod._id;

  const referringPhysicianAndUnit = documents.find(d => d.treatmentPeriodId === treatmentId);

  return (
    <HistorySection
      headerText={<span style={{ fontSize: '2.2rem' }}>{fm('diagnosis.ninmt.referringPhysicianAndUnit.title')}</span>}
      hasHistoryRows={false}
      newButton={
        startEdit
          ? newButton(
              'referringPhysicianAndUnit',
              (e: React.MouseEvent): void => {
                if (!treatmentId) return;
                startEdit(referringPhysicianAndUnit ?? {}, 'referringPhysicianAndUnit', {
                  treatmentPeriodId: treatmentId,
                })(e);
              },
              'general.edit',
              undefined,
              true,
              !isNil(referringPhysicianAndUnit?._lockedFor ?? null) ||
                (treatmentPeriod._editing ?? false) ||
                !treatmentPeriod.date,
              isNil(referringPhysicianAndUnit?._lockedFor)
                ? 'diagnosis.ninmt.treatmentPeriodDisabledTooltip'
                : undefined,
              undefined,
              referringPhysicianAndUnit,
            )
          : undefined
      }
      menuItems={editHistoryMenuItems(referringPhysicianAndUnit)}
    >
      <Container>
        <Item xs={0} md={3} lg={3} />
        <Item xs={12} md={9} lg={9}>
          <HistoryRowVerticalItem
            header={fm('diagnosis.ninmt.referringPhysicianAndUnit.referringPhysician')}
            headerWidth={5}
            value={referringPhysicianAndUnit?.referringPhysician ?? '-'}
          />
          <HistoryRowVerticalItem
            header={fm('diagnosis.ninmt.referringPhysicianAndUnit.unit')}
            headerWidth={5}
            value={referringPhysicianAndUnit?.unit ?? '-'}
          />
        </Item>
      </Container>
    </HistorySection>
  );
};

export default withHistoryContext(ReferringPhysicianAndUnitHistory);
